import { loadUserAgencies } from '../api/agency-service';
import { subscriptionTiers } from '../constants/subscription-tiers';
import { getCookie } from '../utils/cookie-utils.js';
import { parseFullName } from '../utils/string-utils.js';

export const updateStoreWithSessionInfo = (
  user,
  isMobile = false,
  setFetchingInfo,
  dispatch
) => {
  dispatch({ type: 'UPDATE_NAME', payload: user?.name || '' });
  dispatch({ type: 'UPDATE_EMAIL', payload: user?.email || '' });

  loadUserAgencies()
    .then(agencies => {
      const currentAgency = agencies.find(
        agency => agency.id === user.agencyId
      );
      const tierChoice =
        subscriptionTiers[currentAgency?.subscriptionTier] ||
        subscriptionTiers.TEAM;
      dispatch({ type: 'UPDATE_PLAN', payload: tierChoice });
      dispatch({
        type: 'UPDATE_COMPANY_NAME',
        payload: currentAgency?.companyName || '',
      });

      const whiteLabelSettings = currentAgency?.whiteLabel;
      if (whiteLabelSettings) {
        dispatch({
          type: 'UPDATE_DOMAIN',
          payload: whiteLabelSettings?.domain || 'cldportal.com',
        });
        dispatch({
          type: 'UPDATE_SUBDOMAIN',
          payload: whiteLabelSettings?.subdomain || '',
        });
        dispatch({
          type: 'UPDATE_AGENCY_WHITE_LABEL_SUBDOMAIN',
          payload: whiteLabelSettings?.subdomain || '',
        });
      }

      dispatch({ type: 'UPDATE_ACTIVE_STEP', payload: isMobile ? 3 : 1 });
    })
    .catch(error => {
      console.error('Error fetching agencies:', error);
    })
    .finally(() => {
      setFetchingInfo(false);
    });
};

export const trackSignupInHubspot = (userData) => {
    if (typeof window === 'undefined') return;

    window._hsq = window._hsq || [];
    const hsq = window._hsq;

    const fullName = (userData.fullName || '').trim();
    const { firstName, lastName } = parseFullName(fullName);

    const affiliateId = getCookie('affiliate_id');
    const clickId = getCookie('click_id');

    const identity = {
      email: userData.email,
      firstname: firstName,
      lastname: lastName,
      full_name: fullName,
      company: userData.companyName,
      lead_source: 'Self-Serve',
      client_count: userData.clientCount,
      ...(userData.phoneNumber ? { phone: userData.phoneNumber } : {}),
      ...(userData.plan ? { plan: userData.plan.name } : {}),
      ...(affiliateId ? { affiliate_id: affiliateId } : {}),
      ...(clickId ? { click_id: clickId } : {}),
    };

    hsq.push(['identify', identity]);
    hsq.push(['trackPageView']);
    console.log('Tracked signup in Hubspot', identity);
  }
